<template>
  <div>
    <v-container class="ml-10">
      <p class="display-1 mt-7">쇼핑몰 설정</p>
      <p class="mb-0 subtitle-1 font-weight-light">
        쇼핑몰에 정품 인증 페이지를 제공하여 고객이 인증 받을 수 있게 합니다.
      </p>
      <div v-if="mallType !== 'imweb'">
        <p class="mb-0 subtitle-1 font-weight-light">
          PC와 모바일 디자인 스킨에 정품 인증 페이지를 만들 수 있어요.
        </p>
        <p class="mb-0 subtitle-1 font-weight-light">
          [카페24 관리자 > 사이트 설정 > 쇼핑몰 환경설정] 메뉴에서 화면 경로를 설정해주셔야 정상 동작합니다.
        </p>
        <p class="mb-0 subtitle-1 font-weight-light">
          설정이 완료된 후에 메뉴나 배너에 아래 링크 주소를 연결하여 사용해주세요.
        </p>
        <p class="mb-0 subtitle-1 font-weight-light" style="color:#1976d2; text-decoration: underline;    ">
          👉 쇼핑몰도메인/registration/index.html
        </p>
      </div>
      <div v-else>
        <p class="mb-0 subtitle-1 font-weight-light">
          가이드에 따라 정품 인증 화면을 만들어 보세요.
        </p>
        <p class="mb-0 subtitle-1 font-weight-light">
          설정이 완료된 후 아래 URL 경로로 사용하실 수 있습니다.
        </p>
        <p class="mb-0 subtitle-1 font-weight-light" style="color:#1976d2; text-decoration: underline;    ">
          👉 쇼핑몰도메인/registration
        </p>
      </div>

      <v-tabs class="mt-10">
        <v-tab class="title">정품 인증 화면 만들기</v-tab>
        <v-tab-item v-if="mallType !== 'imweb'">
          <DesignMake></DesignMake>
        </v-tab-item>
        <v-tab-item v-else>
          <ImwebDesignMake></ImwebDesignMake>
        </v-tab-item>
        <v-tab class="title">노출 문구 설정하기</v-tab>
        <v-tab-item>
          <InfoTextSetting></InfoTextSetting>
        </v-tab-item>
      </v-tabs>
    </v-container>
  </div>
</template>

<script>
import DesignMake from "@/components/authservice/setting/DesignMake.vue";
import ImwebDesignMake from "@/components/authservice/setting/ImwebDesignMake.vue";
//import PcScreenMake from "@/components/authservice/setting/PcScreenMake.vue";
//import MobileScreenMake from "@/components/authservice/setting/MobileScreenMake.vue";
import InfoTextSetting from "@/components/authservice/setting/InfoTextSetting.vue";

export default {
  components: {
    //PcScreenMake,
    //MobileScreenMake,
    InfoTextSetting,
    DesignMake,
    ImwebDesignMake,
  },
  computed: {
    // Add any computed properties here
    mallType() {
      return this.$store.state.mallType;
    },
  },
};
</script>
